import { createSelector } from 'reselect';
import { sortBy } from 'lodash';

export const sortByName = createSelector(
    state => state,
    (item) => {
        return item ? sortBy(item, i => i.Name.English) : [];
    }
);

export const sortByTradeskill = createSelector(
    state => state,
    (recipes) => {
        return recipes ? sortBy(recipes, ['RequiredSkill','RequiredSkillPoints']) : [];
    }
)


// WEBPACK FOOTER //
// ./src/items/selectors/simpleNameSortSelector.js